
const FactureChoiceForm = function(element) {
    this.element = $(element);
    this.form = this.element.closest('form');

    this.agence = this.form.find('[name$="\[agence\]"]');
    this.client = this.form.find('[name$="\[client\]"]');

    this.agence.on('change', $.proxy(this.resetValue, this));
    this.client.on('change', $.proxy(this.resetValue, this));

    this.element.select2({
        ajax: {
            url: this.element.attr('data-url'),
            dataType: 'json',
            data: params => {
                return {
                    search: params.term,
                    page: params.page || 1,
                    filter_form_facture: this.getFilterFormParams()
                }
            },
            processResults: response => {
                const results = [];

                $.each(response.data, (index, facture) => {
                    const text = facture.numero + ' (' + facture.client.labelTiers + ')';

                    results.push({
                        id: facture.id,
                        text: text
                    });
                });

                return {
                    results: results,
                    pagination: {
                        more: response.page < response.pages
                    }
                }
            }
        }
    });
}

$.extend(FactureChoiceForm.prototype, {
    resetValue: function() {
        this.element.val(null).trigger('change');
    },

    getFilterFormParams: function() {
        const params = {
            type: 'facture'
        };

        if (this.agence.length) {
            params.agence = this.agence.val();
        }

        if (this.client.length) {
            params.client = this.client.val();
        }

        return params;
    }
});

const factureChoiceForm = () => {
    const selector = 'select[data-facture-choice]';

    $(document).arrive(selector, {
        existing: true
    }, function() {
        new FactureChoiceForm(this);
    });
};

export { factureChoiceForm }


// WEBPACK FOOTER //
// ./js/form/factureChoice.js